import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { OLAF } from 'HubStyleTokens/colors';
import { StyledWave } from './Wave.styles';
export const Wave = ({
  waveType
}) => {
  return /*#__PURE__*/_jsx(StyledWave, {
    children: /*#__PURE__*/_jsx("div", {
      className: `Wave ${waveType}`,
      children: /*#__PURE__*/_jsx("div", {
        className: "Wave__Wrapper",
        children: /*#__PURE__*/_jsxs("svg", {
          viewBox: "0 0 1990 500",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M 0 0 C 382 0 573 182 955 182 L 955 182 L 955 0 L 0 0 Z",
            fill: OLAF,
            strokeWidth: "0"
          }), /*#__PURE__*/_jsx("path", {
            d: "M 954 182 C 1368.4 182 1575.6 83 1990 83 L 1990 83 L 1990 0 L 954 0 Z",
            fill: OLAF,
            strokeWidth: "0"
          })]
        })
      })
    })
  });
};